import { useAuth } from '../../context/AuthContext'
import { DashboardWidgetGrid } from '../../components/dashboard/DashboardWidgetGrid'
import { getWidgetsForRole } from '../../components/dashboard/registry'

export default function AdminDashboard() {
  const { user } = useAuth()
  const widgets = user ? getWidgetsForRole(user.role) : []

  return (
    <div className="max-w-[1000px]">
      <div className="mb-8">
        <h1 className="m-0 mb-1 text-[1.4rem] font-bold text-text-heading">
          Admin Dashboard
        </h1>
        <p className="m-0 text-[0.9rem] text-text-3">
          Signed in as {user?.full_name ?? user?.email}
        </p>
      </div>

      <DashboardWidgetGrid widgets={widgets} />
    </div>
  )
}
